import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { LoginRoute } from './routes/Login';
import { LoginCallbackRoute } from './routes/LoginCallback';
import { OverviewRoute } from './routes/Overview';
import { TenantsRoute } from './routes/Tenants';
import { TenantDetailLayout } from './routes/tenant/TenantDetailLayout';
import { TenantOverview } from './routes/tenant/Overview';
import { TenantWorkspaces } from './routes/tenant/Workspaces';
import { TenantEvents } from './routes/tenant/Events';
import { TenantLogs } from './routes/tenant/Logs';
import { TenantSettings } from './routes/tenant/Settings';
import { WorkspaceDetailRoute } from './routes/workspace/WorkspaceDetail';
import { FleetRoute } from './routes/Fleet';
import { IncidentsRoute } from './routes/Incidents';
import { IncidentDetailRoute } from './routes/IncidentDetail';
import { LogsRoute } from './routes/Logs';
import { AuditRoute } from './routes/Audit';
import { StaffRoute } from './routes/Staff';
import { CostsRoute } from './routes/Costs';
import { PlansRoute } from './routes/Plans';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginRoute /> },
  { path: '/login/callback', element: <LoginCallbackRoute /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppShell />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <OverviewRoute /> },
      { path: 'tenants', element: <TenantsRoute /> },
      {
        path: 'tenants/:slug',
        element: <TenantDetailLayout />,
        children: [
          { index: true, element: <TenantOverview /> },
          { path: 'workspaces', element: <TenantWorkspaces /> },
          { path: 'events', element: <TenantEvents /> },
          { path: 'logs', element: <TenantLogs /> },
          { path: 'settings', element: <TenantSettings /> },
        ],
      },
      { path: 'tenants/:slug/workspaces/:workspaceId', element: <WorkspaceDetailRoute /> },
      { path: 'fleet', element: <FleetRoute /> },
      { path: 'incidents', element: <IncidentsRoute /> },
      { path: 'incidents/:id', element: <IncidentDetailRoute /> },
      { path: 'logs', element: <LogsRoute /> },
      { path: 'audit', element: <AuditRoute /> },
      { path: 'costs', element: <CostsRoute /> },
      { path: 'plans', element: <PlansRoute /> },
      { path: 'staff', element: <StaffRoute /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
